import { useRouteError } from "react-router";
import ErrorBoundary from "./ErrorBoundary";

export default function RouteError() {
  const error = useRouteError();
  return <ErrorBoundary error={error} isRouteError={true} />;
}
